import React from 'react';
import { Button, Table, Card, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const RepositoryList = ({ repositories, loading, error }) => {
  const navigate = useNavigate();

  const handleCreateRepo = () => {
    navigate('/create-repo');
  };

  const handleManageCollaborators = (repoName) => {
    navigate(`/collaborators/${repoName}`);
  };

  const handleBranchManagement = (repoName) => {
    navigate(`/branches/${repoName}`);
  };

  if (loading) {
    return (
      <div className="text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p>Loading repositories...</p>
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <Button variant="primary" onClick={handleCreateRepo}>
          Create Repository
        </Button>
      </Card.Header>
      <Card.Body>
        {repositories.length === 0 ? (
          <p>No repositories found.</p>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Privacy</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {repositories.map((repo) => (
                <tr key={repo.id}>
                  <td>
                    <a
                      href={repo.html_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {repo.full_name}
                    </a>
                  </td>
                  <td>{repo.description}</td>
                  <td>{repo.private ? 'Private' : 'Public'}</td>
                  <td>
                    <Button
                      variant="info"
                      size="sm"
                      className="me-2"
                      onClick={() =>
                        handleManageCollaborators(repo.name)
                      }
                    >
                      Manage Collaborators
                    </Button>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() =>
                        handleBranchManagement(repo.name)
                      }
                    >
                      Manage Branches
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default RepositoryList;
